"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireWildcard(require("react"));
var _lodash = _interopRequireDefault(require("lodash.uniqby"));
var _useRecommendationHandsets = require("../../hooks/recommendation/useRecommendationHandsets");
var _services = require("../../services");
var _useRecommendationTabs = require("../../hooks/recommendation/useRecommendationTabs");
var _ProductCard = _interopRequireDefault(require("./ProductCard/ProductCard"));
var _useDynamicPageContent = _interopRequireDefault(require("../../hooks/dynamic/useDynamicPageContent"));
var _constants = require("../../utils/constants");
var _useConfig = _interopRequireDefault(require("../../hooks/useConfig"));
var _useLocalTheme = _interopRequireDefault(require("../../hooks/useLocalTheme"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const StyledTabsWrapper = _styledComponents.default.div`
  @media (min-width: ${_r10SourceLibrary.themeWS10.breakpoints.sm}px) {
    & div[role='tablist'] {
      width: 100%;
    }
    & div[role='presentation'] {
      width: 25%;
    }
    & [class^='TabTitlestyle__TabTitle-sc-'] {
      padding: 5px;
    }
  }

  @media (max-width: 280px) {
    & div[role='presentation'] {
      width: 100%;
    }
  }
`;
const TabTitle = _styledComponents.default.p`
  @media (min-width: ${_r10SourceLibrary.themeWS10.breakpoints.sm}px) {
    display: flex;
    margin-right: 2px;
    white-space: pre-wrap;
    align-items: center;
    margin: ${props => !props.hideDropdown && '0px'};
  }
`;
const RecommendationTabs = () => {
  const recommendationTabsCount = (0, _useConfig.default)('uiSettings.handsetRecommendationTabsCount', null);
  const displayedProductsOrder = (0, _useConfig.default)('displayedProductsOrder', _constants.DISPLAYED_PRODUCTS_ORDER);
  const disableTabsDropdown = (0, _useLocalTheme.default)('recommendation.disableTabsDropdown', false);
  const {
    recommendedHandset,
    premiumHandset,
    budgetHandset,
    alternativePremiumHandset,
    alternativeBudgetHandset,
    selectedHandset
  } = (0, _useRecommendationHandsets.useRecommendationHandsets)();
  let handsets = (0, _lodash.default)([recommendedHandset, premiumHandset, alternativePremiumHandset, alternativeBudgetHandset, budgetHandset].sort((product1, product2) => {
    return (displayedProductsOrder === null || displayedProductsOrder === void 0 ? void 0 : displayedProductsOrder.indexOf(product1 === null || product1 === void 0 ? void 0 : product1.tier)) - (displayedProductsOrder === null || displayedProductsOrder === void 0 ? void 0 : displayedProductsOrder.indexOf(product2 === null || product2 === void 0 ? void 0 : product2.tier));
  }).filter(handset => !!handset), p => p.productId);
  if (recommendationTabsCount && !isNaN(Number(recommendationTabsCount))) {
    handsets = handsets.slice(0, Number(recommendationTabsCount));
  }
  const {
    onTabSwitch
  } = (0, _useRecommendationTabs.useRecommendationTabs)();
  const {
    setDynamicContentPage
  } = (0, _useDynamicPageContent.default)();
  const containerPaddingLevel = (0, _useLocalTheme.default)('recommendation.containerPaddingLevel', 1);
  const TabsWrapper = disableTabsDropdown ? StyledTabsWrapper : _react.Fragment;
  const market = (0, _useConfig.default)('market');
  const getTabText = tier => {
    const options = {
      market,
      allowMissingKey: true
    };
    const translationResult = _services.locale.localeString(`Recommendation.${tier}-handset`, options) || _services.locale.localeString(`Recommendation.${tier}`);
    return translationResult;
  };
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    paddingLevel: containerPaddingLevel
  }, /*#__PURE__*/_react.default.createElement(TabsWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Tabs, {
    tabs: {
      width: 'stretch'
    },
    onTabClick: onTabSwitch,
    externallySetTabId: selectedHandset === null || selectedHandset === void 0 ? void 0 : selectedHandset.productId,
    dataAttributes: {
      'data-testid': 'recommendation-tabs-id'
    }
  }, handsets.map((handset, index) => {
    return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Tab, {
      key: handset.productId,
      text: /*#__PURE__*/_react.default.createElement(TabTitle, {
        "data-testid": `recommendation-tab-${index}`,
        hideDropdown: disableTabsDropdown
      }, getTabText(handset.tier)),
      id: handset.productId
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        top: 3
      }
    }, /*#__PURE__*/_react.default.createElement(_ProductCard.default, {
      handset: handset,
      handsetIndex: index,
      onFullSpecsShow: () => {
        setDynamicContentPage(_constants.DYNAMIC_PAGES.FULL_SPECS);
      }
    })));
  }))));
};
var _default = RecommendationTabs;
exports.default = _default;